import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupervisorService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listSupervisors(filters = "") {
    return this.http.get(this.api+`/supervisor${filters}`);
  }

  getSupervisor(id) {
    return this.http.get(this.api+`/supervisor/${id}`);
  }

  addSupervisor(raw) {
    return this.http.post(this.api+`/supervisor`, raw);
  }

  editSupervisor(raw) {
    return this.http.put(this.api+`/supervisor`, raw);
  }
}
